import React, {createContext, useContext} from "react"
import {useTranslation} from "react-i18next"
import {ProgressIndicator} from "../app/ProgressIndicator"

const SalesTranslationContext = createContext(undefined)

export const SalesTranslationProvider = ({children}) => {
    const {t, ready} = useTranslation("bpn.sales", {useSuspense: false})

    if (ready) {
        return (
            <SalesTranslationContext.Provider value={t}>
                {children}
            </SalesTranslationContext.Provider>
        )
    } else {
        return <ProgressIndicator/>
    }
}

export const useSalesTranslation = () => {
    return useContext(SalesTranslationContext)
}